import React, { useEffect, useState } from 'react';
import * as Styled from './styled';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { ReportResult, InProgressStatus } from '../../../models';
import { fetchReportExport, fetchReportExportCSV } from '../../../api';
import { downloadFile, FileTypes } from '../../../util';
import { Icon } from '../../../components';

interface ExportToExcelButtonCellProps {
  cell: TableCell;
}

const createExportToExcelButtonCell = () => ({
  cell,
}: ExportToExcelButtonCellProps): JSX.Element => {
  const rowData = cell.row.original as ReportResult;
  const allowExportToCSV = rowData.isInforReport;

  const [isExportDisabled, setIsExportDisabled] = useState(rowData.statusId !== InProgressStatus.taskComplete);

  useEffect(()=>{
    setIsExportDisabled(rowData.statusId !== InProgressStatus.taskComplete)
  }, [rowData.statusId])

  const clickHandler = (): void => {
    setIsExportDisabled(true);
    const fileName = rowData.taskName || 'SavedReport';

    const fetchExportFile = async (): Promise<void> => {
      if (allowExportToCSV) {
        const response = await fetchReportExportCSV(rowData.taskId);
        downloadFile(response.body, fileName, FileTypes.csv);
      } else {
        const response = await fetchReportExport(rowData.taskId);
        downloadFile(response.body, fileName, FileTypes.xlsx);
      }
      setIsExportDisabled(false);
    };
    fetchExportFile();
  };

  return (
    <Styled.ActionButton onClick={clickHandler} disabled={isExportDisabled}>
        <Icon name="exportToExcel" disabled={isExportDisabled} />
    </Styled.ActionButton>
  );
};

export default createExportToExcelButtonCell;
